<template>
  <div class="summer_page">
    <div class="first_section" v-if="page==1">
        <div class="back">
            <img src="@/assets/summer/back.png"/>
            <div class="first_section__txt_area">
                <div class="first_section__txt_img">
                    <img class="txt" src="@/assets/summer/text.png"/>
                </div>
                <div class="first_section__tit_img">
                    <img class="tit" src="@/assets/summer/title.png"/>
                </div>
                <div class="first_section__sub_img">
                    <img class="sub_txt" src="@/assets/summer/sub_txt.png"/>
                </div>
            </div>
            <div class="first_section__btn">
                <img src="@/assets/summer/choice_btn.png" v-on:click="choiceVerse()"/>
            </div>
        </div>
    </div>
    <div class="second_section" v-if="page==2">
        <div class="back">
            <img src="@/assets/summer/back.png"/>
            <div class="second_section__inner">
                <img src="@/assets/summer/back2.png">
                <div class="second_section__loading">
                    <div class="second_section__loading_img">
                        <img src="@/assets/summer/ship.png"/>
                    </div>
                    <p class="second_section__loading_txt">성구를<br>뽑는 중입니다!</p>
                </div>
                <div class="second_section__logo">
                    <img src="@/assets/summer/logo.png"/>
                </div>
            </div>
        </div>
    </div>
    <div class="third_section" v-if="page==3">
        <div class="back">
            <img src="@/assets/summer/back.png"/>
        </div>
        <div class="transform_area" :class="scroll?'on':''">
            <div class="capture_area">
                <div class="back">
                    <img src="@/assets/summer/back.png"/>
                    <div class="capture_area__inner">
                        <img src="@/assets/summer/back2.png">
                        <div class="capture_area__inner_area">
                            <div class="capture_area__icon">
                                <img src="@/assets/summer/ship.png"/>
                            </div>
                            <div class="capture_area__tit">
                                <p class="capture_area__tit_txt"><b>여름날 냉수</b><b class="light"> 같은</b></p>
                                <p class="capture_area__tit_txt"><b>축복의 말씀</b></p>
                            </div>
                            <div class="capture_area__verse">
                                <p class="capture_area__verse_txt">{{print_verse.verse}}</p>
                                <p class="capture_area__verse_main">{{print_verse.chapter}}</p>
                            </div>
                        </div>
                        <div class="capture_area__logo">
                            <img src="@/assets/summer/logo.png"/>
                        </div>
                    </div>
                    <div class="capture_area__arrow" v-on:click="scrollClick()">
                        <img src="@/assets/summer/arrow.png"/>
                        <p class="capture_area__arrow_txt">Menu</p>
                    </div>
                </div>
            </div>
            <div class="menu_area">
                <div class="back">
                    <img src="@/assets/summer/back.png"/>
                </div>
                <div class="menu_area__inner">
                    <img src="@/assets/summer/back2.png">
                    <div class="capture_area__inner_area">
                        <div class="menu_area__icon">
                            <img src="@/assets/summer/ship.png"/>
                        </div>
                        <div class="menu_area__tit">
                            <p class="menu_area__tit_txt"><b>여름날 냉수</b><b class="light"> 같은</b></p>
                            <p class="menu_area__tit_txt"><b>축복의 말씀</b></p>
                        </div>
                        <ul class="menu_area__list">
                            <li class="menu_area__item">
                                <img src="@/assets/summer/again.png" v-on:click="choiceVerse()"/>
                            </li>
                            <li class="menu_area__item">
                                <img src="@/assets/summer/copy.png" v-on:click="shareClick()"/>
                            </li>
                            <li class="menu_area__item">
                                <img src="@/assets/summer/img_save.png" v-on:click="imgSave()"/>
                            </li>
                            <li class="menu_area__item">
                                <img src="@/assets/summer/another.png" v-on:click="gotoAnother()"/>
                            </li>
                            <li class="menu_area__item">
                                <img src="@/assets/summer/go_ws.png" v-on:click="gotoWs()"/>
                            </li>
                        </ul>
                    </div>
                    <div class="menu_area__logo">
                        <img src="@/assets/summer/logo.png"/>
                    </div>
                </div>
                <div class="menu_area__arrow" v-on:click="scrollClick()">
                    <img src="@/assets/summer/arrow2.png"/>
                    <p class="capture_area__arrow_txt">돌아가기</p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props : ['verse','scroll','page','print_verse'
            ,'goto_choice','scroll_click','share_fun','goto_another','goto_ws','image_save'],
    methods: {
        choiceVerse(){
            this.goto_choice();
        },
        scrollClick(){
            this.scroll_click();
        },
        shareClick(){
            this.share_fun();
        },
        gotoAnother(){
            this.goto_another();
        },
        gotoWs(){
            this.goto_ws();
        },
        imgSave(){
            this.image_save();
        }
    },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/scss/summer.scss';
</style>
